import Settlements from '@components/reports/settlements';
import { IResourceComponentsProps } from '@refinedev/core';
import { FilterContextProvider } from 'contexts/filter.context';

export const SettlementsIndex: React.FC<IResourceComponentsProps> = () => {
    return (
        <FilterContextProvider>
            <Settlements />
        </FilterContextProvider>
    );
};
